import { AppBar, Box, Toolbar, useTheme } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	PrintButton,
	RHookFormTextField,
	SubmitButton,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { GenerateXMLButton } from "../../GenerateXMLButton";
import { IAppState } from "../../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { useSelector } from "react-redux";

export interface IT4SummaryToolbar {
	t4SlipSummaryScreenPermissions: any;
	onGenerateXMLClicked: () => void;
	onPrintClicked: () => void;
	isSubmitting: boolean;
	onDeleteClicked: () => void;
	SummaryResponseToPass: any;
	pageTitle: string;
}

export const T4SummaryToolbar: FC<IT4SummaryToolbar> = ({
	t4SlipSummaryScreenPermissions,
	onGenerateXMLClicked,
	onPrintClicked,
	isSubmitting = false,
	onDeleteClicked,
	SummaryResponseToPass,
	pageTitle,
}) => {
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [subMenuVisibilityState, setSubMenuVisibility] =
		useState(subMenuVisibility);
	useEffect(() => {
		if (subMenuVisibility) {
			setSubMenuVisibility(subMenuVisibility);
		}
	}, [subMenuVisibility]);
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingBottom: "16px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
				// top: "112px",
			}}
		>
			<Toolbar
				sx={{
					paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
					paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingRight: { sm: 0, md: 0, lg: 0, xl: 0 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div
						// style={{ display: "flex", width: "50%", alignItems: "center" }}
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div
							style={{
								alignSelf: "center",
								paddingRight: "12px",
							}}
						>
							{/* <SubmitButton
							label="Submit"
							testId="submit-button"
							loading={isSubmitting}
							icon={<PlaylistAddCheckOutlinedIcon />}
						/> */}
							<EnhancedButtonPrimeReact
								label="Submit"
								loading={isSubmitting}
								type="submit"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
						</div>
						<Box
							sx={{
								"& .MuiTextField-root": {
									marginBottom: "0!important",
									marginTop: "2px!important",
								},
								"& .MuiTextField-root input": {
									padding: "7.2px 14px!important",
								},
							}}
						>
							<RHookFormTextField
								id="confirmationCode"
								testId={"confirmation-number"}
								placeholder="Confirmation Number"
							/>
						</Box>
						{isAdminUser === 400 ? (
							<Box sx={{ display: "flex", alignItems: "center" }}>
								{/* <DeleteButton
								onClickHandler={onDeleteClicked}
								testId="delete-button"
							/> */}
								<EnhancedButtonPrimeReact
									label="Delete"
									raised
									onClickHandler={onDeleteClicked}
									style={{ marginLeft: "1rem" }}
									severity={EnhancedButtonPrimeReactSeverity.Danger}
								/>
							</Box>
						) : (
							<></>
						)}
					</div>
					{/* <div style={{ flexGrow: 1 }} /> */}
					<div>
						{t4SlipSummaryScreenPermissions && t4SlipSummaryScreenPermissions["Generate XML"] && t4SlipSummaryScreenPermissions["Generate XML"] ? <GenerateXMLButton
							onClickHandler={onGenerateXMLClicked}
							testId="summary-generate-xml-button"
						/> : <></>}
						<PrintButton
							onClickHandler={onPrintClicked}
							testId="summary-print-button"
							label={"Print"}
						/>
					</div>
				</div>
			</Toolbar>
		</AppBar>
	);
};
